#import "@/components/common/RoutinePreviewFragment.gql"

fragment WorkoutCollectionPreviewFragment on workoutCollection_Entry {
  typeHandle
  id
  slug
  uri
  title
  seoTopics
  image {
    kind
    url
  }
  video {
    ...CraftAssetFragment
  }
  duration
  teaserText
  description
  instructions
  products {
    ... on products_Entry {
      uri
      title
      icon {
        url
      }
    }
  }
  sports {
    title
  }
  painPoints {
    title
  }
  trainingGoals {
    title
  }
  difficulty {
    title
  }
  exerciseCount
  pimWorkout
}

fragment AddOnTrainingChapterFragment on addOnTrainingChapter_Entry {
  typeHandle
  heading
  body
  routines: addOnRoutines {
    ... on routine_Entry {
      ...RoutinePreviewFragment
    }
    ... on workoutCollection_Entry {
      ...WorkoutCollectionPreviewFragment
    }
  }
}
